module.exports = __webpack_public_path__ + "static/media/services_logo_scimetrika.4ad066ca.png";